import { jsx as _jsx } from "react/jsx-runtime";
import { MeControl } from '@msrceng/auth';
import { useMeProfileImageApi } from '../../api/me';
import { useMsal } from '@azure/msal-react';
import { mergeStyles } from '@fluentui/react';
/** Builtin "me" user controller (provided by the MeControl team) */
export const DefaultMeControl = ({ defaultMeControl, meControlCommandList = [], }) => {
    const { instance } = useMsal();
    instance.getActiveAccount();
    useMeProfileImageApi();
    if (!defaultMeControl) {
        return null;
    }
    return (_jsx("div", Object.assign({ className: mergeStyles({
            '.hideAccount #mectrl_viewAccount': {
                display: 'none',
            },
            '.mectrl_headertext': {
                display: 'none',
            },
        }), style: { minWidth: '2em' } }, { children: _jsx(MeControl, { meControlCommandList: [...meControlCommandList] }) })));
};
